<template>
  <div class="offline-timer-base">
    <v-container justify-center style='padding-top: 10px; padding-bottom: 0;'>
      <v-card flat>
        <offline-timer-scramble @new-scramble="newScramble"/>
      </v-card>
    </v-container>
    <timer-counter :timerEnabled='timerEnabled' @begin-timer="$emit('begin-timer')" @stop-timer="$emit('stop-timer')" />
  </div>
</template>

<script>
import OfflineTimerScramble from '@/components/OfflineTimerScramble'
import TimerCounter from '@/components/TimerCounter'
export default {
  name: 'offline-timer-base',
  data () {
    return {
      timerEnabled: true
    }
  },
  methods: {
    newScramble (data) {
      this.$emit('new-scramble', data)
    }
  },
  components: {
    OfflineTimerScramble,
    TimerCounter
  }
}
</script>
